import {
  FeatureFlagRole,
  getDefinedRolesWithPermissions,
  isServiceAdminRole,
  Permission,
} from '@tp-vision/roles-permissions';

/**
 * The permissions that apply while a Service Admin works inside another organization under an
 * access grant: only what their Service Admin roles grant (plus feature flags such as Staff). Their
 * own organization role (Owner, Admin, …) applies only in their own organization. The API applies
 * the same rule (`getServiceAdminPermissions` in @tp-vision/roles-permissions).
 */
export function getServiceAdminPermissions(
  roles: string[],
  permissions: Permission[],
): Permission[] {
  const rolesWithPermissions = getDefinedRolesWithPermissions();

  const allowed = new Set<Permission>([
    ...roles.filter(isServiceAdminRole).flatMap((role) => rolesWithPermissions[role]),
    ...Object.values(FeatureFlagRole).flatMap((role) => rolesWithPermissions[role]),
  ]);

  return permissions.filter((permission) => allowed.has(permission));
}
